import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { Filter, Filter$reflection } from "../Search/Model.js";
import { class_type, union_type, string_type, record_type, bool_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Page$reflection as Page$reflection_1 } from "../Invoicee/Model.js";
import { bind, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { SimpleJson_tryParse } from "../../fable_modules/Fable.SimpleJson.3.21.0/SimpleJson.fs.js";
import { Convert_fromJson } from "../../fable_modules/Fable.SimpleJson.3.21.0/Json.Converter.fs.js";
import { createTypeInfo } from "../../fable_modules/Fable.SimpleJson.3.21.0/TypeInfo.Converter.fs.js";
import { logw } from "../../Utils.js";
import { getItem } from "../../LocalStorage.js";
import { FSharpSet__Contains, empty } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { compare } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { ofArray, map } from "../../fable_modules/fable-library.3.7.20/List.js";

export class SearchFilter extends Record {
    constructor(Filter, IsChecked) {
        super();
        this.Filter = Filter;
        this.IsChecked = IsChecked;
    }
}

export function SearchFilter$reflection() {
    return record_type("Containers.CustomerContract.Model.SearchFilter", [], SearchFilter, () => [["Filter", Filter$reflection()], ["IsChecked", bool_type]]);
}

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Welcome", "Search", "Invoicee", "RegisterInvoicee", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.CustomerContract.Model.Page", [], Page, () => [[], [["Item", string_type]], [["Item", Page$reflection_1()]], [], []]);
}

export function getInitialSearchFilters() {
    const activeFilters = defaultArg(bind((str) => {
        let matchValue;
        let matchValue_1;
        try {
            matchValue_1 = (new FSharpResult$2(0, (matchValue = SimpleJson_tryParse(str), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Filter$reflection()]))) : (() => {
                throw (new Error("Couldn\u0027t parse the input JSON string because it seems to be invalid"));
            })())));
        }
        catch (ex) {
            matchValue_1 = (new FSharpResult$2(1, ex.message));
        }
        if (matchValue_1.tag === 1) {
            logw(matchValue_1.fields[0]);
            return void 0;
        }
        else {
            return matchValue_1.fields[0];
        }
    }, getItem("CustomerContract.Update", "Search.Filters")), empty({
        Compare: compare,
    }));
    return map((searchFilter) => {
        if (FSharpSet__Contains(activeFilters, searchFilter.Filter)) {
            return new SearchFilter(searchFilter.Filter, true);
        }
        else {
            return new SearchFilter(searchFilter.Filter, false);
        }
    }, ofArray([new SearchFilter(new Filter(3), false), new SearchFilter(new Filter(0), false), new SearchFilter(new Filter(1), false), new SearchFilter(new Filter(2), false), new SearchFilter(new Filter(4), false)]));
}

